import { useParams } from "react-router-dom";
import { useGame } from "../api/copenhunt/v1/copenhunt_rbt_react";
import { getTeamColors, getObjectiveShapes, getTeamNumbers } from "../utils";

export function useGameData() {
  const { gameId } = useParams<{ gameId: string }>();
  const { useOverview, sendPing } = useGame({ id: gameId ?? "" });

  const { response: overviewResponse, ...rest } = useOverview();
  const playerInfos = overviewResponse?.playerInfos ?? [];
  const locations = overviewResponse?.locations ?? [];
  const teamInfoById = overviewResponse?.teamInfoById;
  const teamIds = teamInfoById ? Object.keys(teamInfoById) : [];
  const events = overviewResponse?.events ?? [];
  const currentTimestamp = overviewResponse?.currentTimestamp;
  const latestPingTimestamp = overviewResponse?.latestPingTimestamp;

  // Sort teams by name, with hunters always first.
  if (teamInfoById) {
    teamIds.sort((a, b) => {
      const teamA = teamInfoById[a];
      const teamB = teamInfoById[b];
      if (teamA.isHunter) return -1;
      if (teamB.isHunter) return 1;
      if (teamA.name < teamB.name) return -1;
      if (teamA.name > teamB.name) return 1;
      return 0;
    });
  }

  const teamColors = getTeamColors(teamIds);
  const objectiveShapes = getObjectiveShapes(locations);
  const teamNumbers = getTeamNumbers(teamIds);

  return {
    sendPing,
    gameId,
    overviewResponse,
    playerInfos,
    locations,
    teamIds,
    teamColors,
    objectiveShapes,
    teamNumbers,
    events,
    currentTimestamp,
    latestPingTimestamp,
    ...rest,
  };
}
